"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PinPad = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
/* eslint-disable @typescript-eslint/no-unused-vars */
const react_1 = require("react");
const sdk_1 = __importDefault(require("@twa-dev/sdk"));
const de_ui_1 = require("@delab-team/de-ui");
const uuid_1 = require("uuid");
const framer_motion_1 = require("framer-motion");
const pinpad_module_css_1 = __importDefault(require("./pinpad.module.css"));
const svg_selector_1 = require("../../assets/svg-selector");
// eslint-disable-next-line no-promise-executor-return
const delay = (delayInms) => new Promise(resolve => setTimeout(resolve, delayInms));
const PinPad = ({ onChange, title, animationState, setAnimationState }) => {
    const [tempPin, setTempPin] = (0, react_1.useState)('');
    const [disable, setDisable] = (0, react_1.useState)(false);
    const [isSuccess, setIsSuccess] = (0, react_1.useState)(undefined);
    const [lastFilledIndex, setLastFilledIndex] = (0, react_1.useState)(-1);
    // console.log('tempPin', tempPin)
    // console.log('lastFilledIndex', lastFilledIndex)
    // console.log('animationState', animationState)
    (0, react_1.useEffect)(() => {
        if (tempPin.length !== 4) {
            console.log('reset animation');
            setAnimationState(undefined);
            onChange('');
        }
    }, [tempPin]);
    const handleButtonClick = (digit) => {
        sdk_1.default.HapticFeedback.impactOccurred('medium');
        if (tempPin.length < 4) {
            const newPin = tempPin + digit;
            setTempPin(newPin);
            setLastFilledIndex(newPin.length - 1);
        }
    };
    const handleDeleteButtonClick = () => {
        sdk_1.default.HapticFeedback.impactOccurred('medium');
        const newPin = tempPin.slice(0, -1);
        setTempPin(newPin);
        setLastFilledIndex(newPin.length - 1);
        console.log('reset animation');
        setAnimationState(undefined);
        onChange('');
    };
    const errorClean = async () => {
        setLastFilledIndex(2);
        await delay(100);
        setLastFilledIndex(1);
        await delay(100);
        setLastFilledIndex(0);
        await delay(100);
        setLastFilledIndex(-1);
        setTempPin('');
    };
    (0, react_1.useEffect)(() => {
        if (tempPin.length === 4) {
            onChange(tempPin);
        }
    }, [tempPin]);
    (0, react_1.useEffect)(() => {
        const animationDuration = async () => {
            if (animationState === 'failure' && tempPin.length === 4) {
                setIsSuccess('failure');
                console.log('animationDuration');
                setDisable(true);
                sdk_1.default.HapticFeedback.notificationOccurred('error');
                await delay(350);
                await errorClean();
                setIsSuccess(undefined);
                await delay(100);
                setDisable(false);
            }
            if (animationState === 'success') {
                setIsSuccess('success');
                console.log('animationDuration');
                setDisable(true);
                sdk_1.default.HapticFeedback.notificationOccurred('success');
                await delay(1000);
                setDisable(false);
                setAnimationState(undefined);
                // setIsSuccess(undefined)
            }
        };
        animationDuration();
    }, [animationState]);
    return ((0, jsx_runtime_1.jsxs)("div", { className: pinpad_module_css_1.default.container, children: [(0, jsx_runtime_1.jsx)("div", { className: pinpad_module_css_1.default.secondTopWrapper, children: (0, jsx_runtime_1.jsxs)("div", { className: pinpad_module_css_1.default.topWrapper, children: [(0, jsx_runtime_1.jsx)(de_ui_1.Text, { className: pinpad_module_css_1.default.topTitle, children: title }), (0, jsx_runtime_1.jsx)(framer_motion_1.motion.div, { className: pinpad_module_css_1.default.pinDots, animate: {
                                scale: isSuccess === 'success' ? [1, 1.15, 1] : 1,
                                x: isSuccess === 'failure' ? [-5, 5, -5, 5, -5, 0] : 0
                            }, 
                            // eslint-disable-next-line no-nested-ternary
                            transition: { duration: isSuccess === 'success' ? 0.25 : isSuccess === 'failure' ? 0.3 : 0 }, children: [0, 1, 2, 3].map((filled, index) => ((0, jsx_runtime_1.jsx)(framer_motion_1.motion.div, { className: `${pinpad_module_css_1.default.pinDot}
                            ${(index <= lastFilledIndex && isSuccess === undefined) ? pinpad_module_css_1.default.filled : ''} 
                            ${(index <= lastFilledIndex && isSuccess === 'failure') ? pinpad_module_css_1.default.failure : ''}
                            ${(index <= lastFilledIndex && isSuccess === 'success') ? pinpad_module_css_1.default.success : ''}
                            `, animate: index === lastFilledIndex ? { scale: [1, 1.2, 1] } : { scale: 1 }, transition: { duration: 0.2 } }, (0, uuid_1.v1)()))) })] }) }), (0, jsx_runtime_1.jsxs)("div", { className: pinpad_module_css_1.default.pinPad, children: [[1, 2, 3, 4, 5, 6, 7, 8, 9].map(digit => ((0, jsx_runtime_1.jsx)("button", { disabled: disable, className: pinpad_module_css_1.default.pinPadButton, onClick: () => handleButtonClick(String(digit)), children: (0, jsx_runtime_1.jsx)(de_ui_1.Text, { className: pinpad_module_css_1.default.numSymbol, children: digit }) }, (0, uuid_1.v1)()))), (0, jsx_runtime_1.jsx)("div", {}), (0, jsx_runtime_1.jsx)("button", { disabled: disable, className: pinpad_module_css_1.default.pinPadButton, onClick: () => handleButtonClick(String(0)), children: (0, jsx_runtime_1.jsx)(de_ui_1.Text, { className: pinpad_module_css_1.default.numSymbol, children: "0" }) }), (0, jsx_runtime_1.jsx)("button", { disabled: disable, className: pinpad_module_css_1.default.delete, onClick: () => handleDeleteButtonClick(), children: (0, jsx_runtime_1.jsx)(svg_selector_1.SvgSelector, { id: 'pinpud-delete' }) })] })] }));
};
exports.PinPad = PinPad;
